import { PhoneCall, Search, Wrench } from "lucide-react";

const STEPS = [
  {
    num: "1",
    icon: PhoneCall,
    title: "Rozmowa o Twoim domu",
    desc: "Oddzwonimy i sprawdzimy, jaka instalacja ma sens dla Twojego domu.",
  },
  {
    num: "2",
    icon: Search,
    title: "Analiza i propozycja",
    desc: "Przygotujemy rozwiązanie dopasowane do dachu i zużycia energii.",
  },
  {
    num: "3",
    icon: Wrench,
    title: "Montaż i uruchomienie",
    desc: "Prowadzimy Cię przez ostatni etap aż do gotowej instalacji.",
  },
];

export default function HowItWorksFotowoltaika() {
  return (
    <section
      id="jak-to-dziala"
      className="py-16 lg:py-24 bg-brand-surface"
      data-testid="how-it-works-fv"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">
            Jak to działa
          </p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl tracking-tight text-brand-ink">
            3 proste kroki do montażu
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {STEPS.map((s) => (
            <div
              key={s.num}
              className="relative bg-white border border-brand-border p-6 lg:p-7 rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              data-testid={`how-step-fv-${s.num}`}
            >
              <div className="flex items-start gap-4">
                <div className="grid place-items-center h-12 w-12 rounded-full bg-brand-yellow text-brand-yellowFg font-heading font-extrabold text-lg flex-shrink-0">
                  {s.num}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 text-brand-blue">
                    <s.icon className="h-4 w-4" strokeWidth={1.8} />
                    <span className="text-xs font-bold uppercase tracking-wider">
                      Krok {s.num}
                    </span>
                  </div>
                  <h3 className="mt-1.5 font-heading font-bold text-xl text-brand-ink">
                    {s.title}
                  </h3>
                </div>
              </div>
              <p className="mt-4 text-brand-muted leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
